import { render, staticRenderFns } from "./overviewCard.vue?vue&type=template&id=6e927443&scoped=true"
import script from "./overviewCard.vue?vue&type=script&lang=js"
export * from "./overviewCard.vue?vue&type=script&lang=js"
import style0 from "./overviewCard.vue?vue&type=style&index=0&id=6e927443&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e927443",
  null
  
)

export default component.exports